/**
 * Created by claudenbach on 1/27/2017.
 */

import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { LMFormatterService } from '@list/formatters';

export const lmBcdSerializer = (
  lmFormatterService: LMFormatterService,
  lmFormatUtilService: LMFormatUtilService,
  value: string,
  oldValue: string,
  columnDef: ListGridColumn,
  row: number,
  cell: number,
  dataView: LMListDataView
): string => {
  const decSize: number = columnDef.displayField.decSize;
  const targetDataView = lmFormatterService.listSpec.isTemplateList ? dataView.dataView : dataView;
  const precision: number = lmFormatterService.getDisplayFieldPrecision(columnDef.displayField, targetDataView);

  return lmFormatUtilService.bcdToData(value, {decSize, precision});
};
